import { gql } from '@apollo/client'
import {
  Docview,
  RecommendedDocuments,
  SeusDireitosWidget,
  ViewLockContext,
  ViewLockWrapper,
} from '@jusbrasil-web/docview/core'
import { ServerSidePersistentAlertBanner } from '@jusbrasil-web/shared-persistent-alert-banner'

import {
  ArticleNewsDocument,
  ArticleNewsMetaTags,
  ArticleNewsToolbar,
  Comments,
  ModerationBanner,
  PublicationHeader,
  PublicationSidebar,
} from '../../components'

export const NewsRoot = gql`
  query newsRoot(
    $docId: NumericID!
    $isNewsPage: Boolean!
    $appPageId: String = "web-docview-news"
  ) {
    root {
      document: documentByNumericID(docId: $docId, artifact: "NOTICIAS") {
        docId
        url
        slug
        status
        isActive
        readingTime
        hasCreditsToViewDocument: viewerCanUseFeature(featureCode: "view_lr_content_1000")

        ...Docview_document
        ...ViewLockContext_document
        ...ViewLockWrapper_document
        ...ArticleNewsDocument_document
        ...PublicationHeader_document
        ...ArticleNewsToolbar_document
        ...RecommendedDocuments_document
        ...Comments_document
        ...PublicationSidebar_document
        ...ModerationBanner_document
        ...ArticleNewsMetaTags_document
      }

      viewer: me {
        pid
        boxProfileInfo {
          linkedAccount
        }
        hasPaidPlan
        viewContentBlocked: isBlockedFeature(featureCode: "view_lr_content_1000")

        ...Docview_viewer
        ...ViewLockContext_viewer
        ...ViewLockWrapper_viewer
        ...PublicationHeader_viewer
        ...ArticleNewsToolbar_viewer
        ...Comments_viewer
        ...SeusDireitosWidget_viewer
      }
      ...ServerSidePersistentAlertBanner_root
    }
  }

  ${Docview.fragments.document}
  ${ViewLockContext.fragments.document}
  ${ViewLockWrapper.fragments.document}
  ${ArticleNewsDocument.fragments.document}
  ${PublicationHeader.fragments.document}
  ${ArticleNewsToolbar.fragments.document}
  ${RecommendedDocuments.fragments.document}
  ${Comments.fragments.document}
  ${PublicationSidebar.fragments.document}
  ${ModerationBanner.fragments.document}
  ${ArticleNewsMetaTags.fragments.document}

  ${Docview.fragments.viewer}
  ${ViewLockContext.fragments.viewer}
  ${ViewLockWrapper.fragments.viewer}
  ${PublicationHeader.fragments.viewer}
  ${ArticleNewsToolbar.fragments.viewer}
  ${Comments.fragments.viewer}
  ${SeusDireitosWidget.fragments.viewer}
  ${ServerSidePersistentAlertBanner.fragments.root}
`
